import * as React from 'react';
import Input from './Input';
import { inject, observer } from 'mobx-react';
import { FEEDBACK_STORE } from '../constants/constants';

interface FeedbackProps {
}

interface FeedbackState {
  title: string;
  body: string;
}

@inject(FEEDBACK_STORE)
@observer
class Feedback extends React.Component<FeedbackProps, FeedbackState> {
  state = {
    title: '',
    body: ''
  };

  onTitleChange(value: string) {
    this.setState({ title: value });
  }

  onBodyChange(value: string) {
    this.setState({ body: value });
  }

  componentDidUpdate() {
    this.props[FEEDBACK_STORE].setFeedback(this.state.title, this.state.body);
  }

  render() {
    return (
      <div className="form form--feedback">
        <div className="input-block">
          <label htmlFor="title">Otsikko</label>
          <Input
            id={'title'}
            onChange={value => this.onTitleChange(value)}
            type={'text'}
          />
        </div>
        <div className="input-wrapper">
          <label htmlFor="body">Viesti</label>
          <textarea
            name="body"
            id="body"
            className="feedback__body"
            onChange={e => this.onBodyChange(e.target.value)}
          />
        </div>
      </div>
    );
  }
}

export default Feedback;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Feedback.tsx